import { QueryClient } from "@tanstack/react-query";

// Cliente único (singleton) compartilhado pelo Providers e pela auth store.
// Mantê-lo fora do React permite limpar o cache ao trocar de sessão (login/logout),
// evitando vazamento de dados em cache entre corretores no mesmo navegador
// (ex.: a proposta de co-corretagem do corretor B aparecendo para o corretor A).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
